<script setup lang="ts">
import { computed } from 'vue'
import FilterDropdown from './FilterDropdown.vue'
import type { FilterDropdownFilter } from './filter_dropdown'

const WIZARD_OVERLAY = "[data-testid='wizard-overlay']"

const props = withDefaults(
  defineProps<{
    filter: FilterDropdownFilter
    before: string
    after?: string
    clearable?: boolean
  }>(),
  { after: '', clearable: true }
)

const emit = defineEmits<{
  select: [value: string | string[] | null]
  open: []
}>()

// The trigger's aria-label replaces its visible text, so it carries the whole sentence
// with the shown value (WCAG 2.5.3); otherwise the chosen value is never announced.
const triggerLabel = computed(() =>
  [props.before, props.filter.valueLabel || props.filter.emptyText, props.after].filter(Boolean).join(' ')
)
</script>

<template>
  <div data-testid="wizard-prompt" class="text-display-md leading-[3.75rem] text-gray-900">
    <span class="italic">{{ before }}</span> <FilterDropdown
      :filter="filter"
      :trigger-label="triggerLabel"
      :clearable="clearable"
      size="lg"
      muted-when-empty
      :container-portal="WIZARD_OVERLAY"
      opens-below-at-full-height
      @open="emit('open')"
      @select="emit('select', $event)"
    /> <span v-if="after" class="italic">{{ after }}</span>
  </div>
</template>
